import http from "./httpService";

const endPoint = "/api/v1/Stock";

export async function getStock(request) {
    return await http.post(`${endPoint}`, request);
}

export default {getStock};


// WEBPACK FOOTER //
// ./src/services/StockService.js